module.exports = __webpack_public_path__ + "img/arrow--dark.33ec6389.svg";